import { call, SagaGenerator, select } from "typed-redux-saga";

import { ActivitySelectors } from "@com.mgmtp.a12.client/client-core/lib/core/activity";
import {
	DataOperation,
	maybeAsyncFnWrapper,
	OverviewEngineFactories,
	ProvideDataResults
} from "@com.mgmtp.a12.overviewengine/overviewengine-core/lib/main/client-extensions";
import { Query } from "@com.mgmtp.a12.dataservices/dataservices-access";

import { assertNonNullable, assertTrue } from "../../utilities/assert";
import { ModulfOverviewEngineDataLoader } from "../../app/provider/modulfOverviewEngineDataLoader";

import { SortingPaths } from "./constants";
import { dataModels } from "./moduleResources";

/**
 * An overview engine loader that adds a fixed filter for processId to the query (so that the user can only see Fristen
 * belonging to the current Antrag)
 */
export const fristLoader: ModulfOverviewEngineDataLoader = {
	*canHandle(params): SagaGenerator<boolean> {
		const { queries, documentModel, activityId } = params;
		if (documentModel.header.id !== dataModels.FRIST_D) {
			return false;
		}

		const [query] = queries;
		if (!DataOperation.ListDocuments.Query.isAssignableFrom(query)) {
			return false;
		}

		const activity = yield* select(ActivitySelectors.activityById(activityId));
		return !!activity?.descriptor.processId;
	},

	*provideData(params): ProvideDataResults {
		const { queries, activityId } = params;
		const [query, ...otherQueries] = queries;
		const activity = yield* select(ActivitySelectors.activityById(activityId));
		let updatedQuery = query;

		assertNonNullable(activity?.descriptor.processId);
		assertTrue(DataOperation.ListDocuments.Query.isAssignableFrom(query));

		// Create a custom constraint to filter products without productType
		const customConstraint: Query.Operator = {
			operator: Query.OPERATORS.EXACT_MATCH_OPERATOR,
			field: SortingPaths.ProcessId,
			value: activity.descriptor.processId
		};

		updatedQuery = {
			...query,
			// Either extends the existing constraint or directly uses it if none exists
			constraint: query.constraint
				? { operator: Query.OPERATORS.AND_OPERATOR, operands: [query.constraint, customConstraint] }
				: customConstraint
		};

		return yield* call(maybeAsyncFnWrapper(OverviewEngineFactories.dataLoader.provideData), {
			...params,
			queries: [updatedQuery, ...otherQueries]
		});
	}
};
